export default __webpack_public_path__ + "static/media/ada.18d1775a.png";